var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.iz=require("ttag");module.exports=$CLJS.iz;